
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: "SADTOOIPFC",
components: {
XTable,
},
};



// WEBPACK FOOTER //
// ./src/pages/formulas/Common/SADTOOIPFC.vue